import classnames from "classnames";
import * as React from "react";

export interface Props {
  active: boolean;
}

const LodLogo = ({ active }: Props) => (
  <svg
    className={classnames("lod-logo", {
      active,
    })}
    width="129px"
    height="34px"
    viewBox="0 0 129 34"
  >
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <g transform="translate(-50.000000, -55.000000)">
        <g transform="translate(50.000000, 50.000000)">
          <g transform="translate(0.000000, 5.000000)">
            <polygon points="-1.97175609e-13 0 -1.97175609e-13 34 25.7078652 34 25.7078652 25.6066023 8.21958358 25.6066023 8.21958358 0" />
            <path
              d="M42.9775281,16.9989415 C42.9775281,25.6308196 49.4192808,32.760991 57.8089888,34 L57.8089888,25.286907 C54.2090024,24.1880034 51.5782207,20.9130398 51.5782207,16.9989415 C51.5782207,13.0850357 54.2090024,9.80814753 57.8089888,8.71097602 L57.8089888,0 C49.4192808,1.23900898 42.9775281,8.36764082 42.9775281,16.9989415"
              id="Fill-2"
            />
            <path
              d="M61.7640449,0 L61.7640449,8.71078356 C65.3644096,9.80814753 67.9958575,13.0848432 67.9958575,16.9989415 C67.9958575,20.9130398 65.3644096,24.1880034 61.7640449,25.286907 L61.7640449,34 C70.1530759,32.760991 76.5955056,25.6306271 76.5955056,16.9989415 C76.5955056,8.36764082 70.1530759,1.23881653 61.7640449,0"
              id="Fill-4"
            />
            <path
              d="M112.436491,25.6065554 L107.513631,25.6065554 L107.513631,8.39230399 L112.436491,8.39230399 C117.070784,8.39230399 120.822707,12.2467374 120.822707,16.9986692 C120.822707,21.7528824 117.070784,25.6065554 112.436491,25.6065554 M112.436491,0 L99.3370787,0 L99.3370787,34 L112.436491,34 C121.584686,34 129,26.387898 129,16.9986692 C129,7.61096139 121.584686,0 112.436491,0"
              id="Fill-6"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default LodLogo;
